import { MediaItem } from '@/types/greenroom/media.types';
import { Get } from '../helpers';
import { GREENROOM_HOST } from '@/utils/connections/endpoints';

const GetMedia = (meetingId: number): Promise<MediaItem[] | null> => {
  return Get({
    host: GREENROOM_HOST,
    path: `/v2/greenroom/media/${meetingId}`,
    includeGreenroomToken: true,
    headers: {
      'bl-global-resource': 'false',
    },
    // Note: do not use cache, we need to make sure we always fetch latest data so we don't
    // accidentally send stale updates to greeenroom shot feeds
  });
};

export default GetMedia;
